import { Component, OnInit, Inject } from '@angular/core';

import { AuthenticationService } from '../../login/authentication.service';

import { MenutitleService } from '../../../shared/menutitle.service';
import { ShowmenuService } from '../../..//shared/showmenu.service';

import { GetparticipantService } from '../participantedit/getparticipant.service';

import { Router, ActivatedRoute } from '@angular/router';

import { first } from 'rxjs/operators';

import { MenucontentService } from '../../../shared/menucontent.service';

import { BarcodeFormat } from '@zxing/library';
import { BehaviorSubject } from 'rxjs';
import { ViewChild } from '@angular/core';
import { ZXingScannerComponent } from '@zxing/ngx-scanner';

import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { BeepService } from '../../../shared/beep.service';
import { VibrateService } from '../../../shared/vibrate.service';

export interface DialogData {
  dialogtitle: string;
  dialogtext: string;
}

@Component({
  selector: 'app-participantscan',
  templateUrl: './participantscan.component.html',
  styleUrls: ['./participantscan.component.css'],
})
export class ParticipantscanComponent implements OnInit {
  //qrResultString: any;
  @ViewChild('scanner', { static: false })
  scanner: ZXingScannerComponent;

  showmenu: boolean;
  timing_json: any;
  stage_type: string;

  selectedCamera = null;
  //cameraCount = 0;

  loading = true;
  availableDevices: MediaDeviceInfo[];
  currentDevice: MediaDeviceInfo = null;
  formatsEnabled: BarcodeFormat[] = [BarcodeFormat.QR_CODE];
  qrResultString: string;

  torchEnabled = false;
  torchAvailable$ = new BehaviorSubject<boolean>(false);
  tryHarder = true;

  gotokeyboard() {
    this.router.navigate(['/participantkeyboard']);
  }

  onCodeResult(resultString: string) {
    this.BeepService.beep();
    this.VibrateService.vibrate();
    this.loading = true;

    this.GetparticipantService.getparticipant(resultString)
      .pipe(first())
      .subscribe({
        next: () => {
          this.router.navigate(['/participantedit', resultString]);
        },
        error: (error) => {
          this.router.navigate(['/participantedit', resultString]);
        },
      });
  }

  onCamerasFound(devices: MediaDeviceInfo[]): void {
    this.availableDevices = devices;

    var cameraCount = 0;

    var a = 1;

    this.availableDevices.forEach(function (cameraObject) {
      var cameraLabel = cameraObject.label;
      var cameraDirection = '';

      if (cameraLabel.includes('front')) {
        cameraDirection = ' (Front)';
      }
      if (cameraLabel.includes('back')) {
        cameraDirection = ' (Back)';
        cameraCount++;
      }

      Object.defineProperty(cameraObject, 'label', {
        value: 'Camera ' + a + cameraDirection,
        writable: true,
      });
      a++;
    });

    //console.log(cameraCount)
    //console.log(localStorage.getItem('global_camera_popup'))
    //cameraCount++;
    //cameraCount++;

    //cameraCount = 1;
    //localStorage.setItem('global_camera_popup', 'No');

    if (
      cameraCount > 1 &&
      localStorage.getItem('global_camera_popup') != 'Yes'
    ) {
      this.openDialog(cameraCount);
      localStorage.setItem('global_camera_popup', 'Yes');
    } else if (localStorage.getItem('global_camera_popup') != 'Yes') {
      this.openDialog(0);
      localStorage.setItem('global_camera_popup', 'Yes');
    }

    setTimeout(() => this.cameraStartUp(), 1000);
  }

  cameraStartUp() {
    this.scanner.device = null;

    // if camera already selected
    var current_camera = localStorage.getItem('global_current_camera');
    if (current_camera != null) {
      this.onDeviceSelectChange(current_camera);
    }

    this.loading = false;
  }

  onDeviceSelectChange(selected: string) {
    localStorage.setItem('global_current_camera', selected);

    this.selectedCamera = selected;

    const device = this.availableDevices.find((x) => x.deviceId === selected);

    this.scanner.device = device || null;
  }

  constructor(
    private GetparticipantService: GetparticipantService,
    private AuthenticationService: AuthenticationService,
    private menutitle: MenutitleService,
    private router: Router,
    private ShowmenuService: ShowmenuService,
    private MenucontentService: MenucontentService,
    private BeepService: BeepService,
    private VibrateService: VibrateService,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.AuthenticationService.check_logged_in();
    this.AuthenticationService.save_current_route();

    this.ShowmenuService.currentshowMenu.subscribe(
      (showmenu) => (this.showmenu = showmenu)
    );

    this.ShowmenuService.changeShowmenu(true);
    this.MenucontentService.changeMenuMassStart();
    this.MenucontentService.changeMenuIndividualStart();
    this.MenucontentService.changeCheckpoints();

    this.menutitle.changeMenutitle('Manage Participants');
    this.menutitle.showMenupink(false);

    localStorage.setItem('global_input_method', 'scan');
    //this.loading = false;
  }

  openDialog(camera_amount) {
    if (camera_amount <= 0) {
      var dialog_text =
        ' Close this popup and click the dropdown to select a camera';

      this.dialog.open(DialogCameraCounterParticipant, {
        height: '230px',
        width: '350px',
        data: { dialogtitle: 'Choose a camera', dialogtext: dialog_text },
      });
    } else {
      var dialog_text =
        'You have ' +
        camera_amount +
        ' cameras on the back of your device.<br /><br />Close this popup and click the dropdown to select a camera.<br /><br />Test all the cameras on the back of your device to find the best one for QR number scanning.';

      this.dialog.open(DialogCameraCounterParticipant, {
        height: '330px',
        width: '350px',
        data: {
          dialogtitle: 'Choose the best camera',
          dialogtext: dialog_text,
        },
      });
    }
  }
}

@Component({
  selector: 'dialog-elements3',
  templateUrl: 'camera.dialog.html',
})
export class DialogCameraCounterParticipant {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialog: MatDialog
  ) {}
}
